import { defineStore } from 'pinia'
import { v4 as uuid } from 'uuid'
import { markRaw } from 'vue'
import { useAuthStore } from './auth'

import SettingIcon from '@/assets/svg/setting.svg?component'
import LoginIcon from '@/assets/svg/login.svg?component'
import LogoutIcon from '@/assets/svg/logout.svg?component'
import CardsIcon from '@/assets/svg/cards.svg?component'

export const useMenuStore = defineStore('menuStore', {
  state: () => ({
    flatNavigationItems: [
      { id: uuid(), label: 'Credits', to: 'account-credits' },
      { id: uuid(), label: 'Newsroom', to: 'account-newsrooms' },
      { id: uuid(), label: 'Order History', to: 'order-history' },
    ],
    dropdownNavigationItems: [
      {
        id: uuid(),
        label: 'Account Settings',
        icon: markRaw(SettingIcon),
        to: 'account-details',
      },
      {
        id: uuid(),
        label: 'Subaccounts',
        icon: markRaw(LoginIcon),
        to: 'account-subaccounts',
        meta: {
          role: {
            master: true,
          },
        },
      },
      {
        id: uuid(),
        label: 'Miscellaneous Purchase',
        icon: markRaw(CardsIcon),
        isButton: true,
        action: 'miscPurchase',
      },
      {
        id: uuid(),
        label: 'Logout',
        icon: markRaw(LogoutIcon),
        isButton: true,
        action: 'logout',
      },
    ],
  }),
  getters: {
    flatNavigation: ({ flatNavigationItems }) => flatNavigationItems,
    dropdownNavigation: ({ dropdownNavigationItems }) => {
      const authStore = useAuthStore()

      return dropdownNavigationItems.filter((item) => {
        if (item?.meta?.role?.master && !authStore?.isMaster) return false
        return item
      })
    },
    allMenuItems: ({ flatNavigationItems, dropdownNavigationItems }) => [
      ...flatNavigationItems,
      ...dropdownNavigationItems,
    ],
  },
})
